import React from "react";
import data from "../data/data.json";

const legalPages = data.LegalPages;

export const Adatkezeles = () => {
    const params = new URLSearchParams(window.location.search);
    const pageKey = params.get("page") || "adatvedelem";
    const current = legalPages[pageKey] || legalPages["adatvedelem"];

    return (
        <div style={{ minHeight: "100vh", background: "#f6f6f6", padding: "60px 0" }}>
            <div style={{ maxWidth: "760px", margin: "0 auto", padding: "0 24px" }}>

                {/* Back link */}
                <a
                    href="/"
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        color: "#5AC7CE",
                        fontWeight: 600,
                        textDecoration: "none",
                        marginBottom: "32px",
                        fontSize: "14px",
                    }}
                >
                    ← Vissza a főoldalra
                </a>

                {/* Tab switcher */}
                <div style={{ display: "flex", gap: "8px", marginBottom: "32px" }}>
                    {Object.entries(legalPages).map(([key, p]) => (
                        <a
                            key={key}
                            href={`/adatkezeles?page=${key}`}
                            style={{
                                padding: "8px 20px",
                                borderRadius: "20px",
                                fontWeight: 600,
                                fontSize: "14px",
                                textDecoration: "none",
                                background:
                                    pageKey === key
                                        ? "linear-gradient(to right, #5AC7CE, #5AC7CE)"
                                        : "#fff",
                                color: pageKey === key ? "#fff" : "#555",
                                border: "1px solid",
                                borderColor: pageKey === key ? "transparent" : "#ddd",
                                boxShadow:
                                    pageKey === key ? "0 2px 8px rgba(99,114,255,0.3)" : "none",
                            }}
                        >
                            {p.title}
                        </a>
                    ))}
                </div>

                {/* Card */}
                <div
                    style={{
                        background: "#fff",
                        borderRadius: "12px",
                        padding: "40px 48px",
                        boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
                    }}
                >
                    <h2 style={{ marginTop: 0, marginBottom: "24px", color: "#222" }}>
                        {current.title}
                    </h2>
                    <div style={{ color: "#444", lineHeight: "1.8", fontSize: "15px" }}>
                        {current.sections.map((s, i) => (
                            <div key={i} style={{ marginBottom: "16px" }}>
                                {s.heading ? (
                                    <h3 style={{ margin: "0 0 6px", color: "#222", fontSize: "16px" }}>
                                        {s.heading}
                                    </h3>
                                ) : null}
                                <p style={{ margin: 0 }}>{s.text}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <p style={{ textAlign: "center", color: "#aaa", fontSize: "13px", marginTop: "32px" }}>
                    © 2026 Gaál Garage
                </p>
            </div>
        </div>
    );
};
